var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-slider',_vm._g(_vm._b({class:_vm.desc.class,style:(_vm.desc.style),on:{"input":_vm.handleChange},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},'el-slider',_vm.attrs,false),_vm.desc.on))}
var staticRenderFns = []

export { render, staticRenderFns }